
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { 
  // Feature,
  FeatureBase,
  // Limitation 
} from "@models";
import { 
  Language,
  Race, 
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";
import { CommonUtilitiesClass } from "@utilities/common_utilities_class";
import { DataType, SizeType } from "@dndModels/Types";


export class Subrace extends DandDFeatureSource {
  data_type: DataType = "subrace";
  feature_source_type = "Subrace";
  race_ids: string[] = [];
  sizes: SizeType[] = [8];
  base_name = "";

  races: Race[] = [];

  constructor(obj?: any) {
    super(obj, "Subrace");
    this.common_util = CommonUtilities.getInstance();
    if (obj) {
      this.race_ids = [];
      if (obj.race_ids) {
        this.race_ids = obj.race_ids;
      } else if (obj.race_id) {
        this.race_ids = [obj.race_id];
      }
      this.sizes = obj.sizes ? obj.sizes : [8];
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature_base = new FeatureBase(o);
          this.feature_bases.push(feature_base);
        });
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.race_ids = [];
  //     if (obj.race_ids) {
  //       this.race_ids = obj.race_ids;
  //     } else if (obj.race_id) {
  //       this.race_ids = [obj.race_id];
  //     }
  //     this.sizes = obj.sizes ? obj.sizes : [8];
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature_base = new FeatureBase(o);
  //         this.feature_bases.push(feature_base);
  //       });
  //     }
  //   }
  // }

  get race_names() {
    return this.races.map(o => o.name).join(", ");
  }

  get_detail_format() {
    const str = `${super.get_detail_format()}; {list_of_type:race;[${this.race_ids}]}`;
    return str.trim();
  }

  common_util: CommonUtilitiesClass;

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      race_ids: this.race_ids,
      sizes: this.sizes
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      race_ids: this.race_ids,
      sizes: this.sizes
    };
  }

  copy(copyMe: Subrace, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.race_ids = [...copyMe.race_ids];
    this.sizes = [...copyMe.sizes];
  }

  clone(drop_ids = false): Subrace {
    const new_obj = new Subrace();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy5e(copyMe: any, race_id: string, languages: Language[]): void {
    // console.log(copyMe);
    // this.race_id = race_id;
    // this.name = copyMe.name;
    // this.description = copyMe.desc;
    // this.feature_bases = [];
    // if ((copyMe.ability_bonuses && copyMe.ability_bonuses.length > 0) || copyMe.ability_bonus_options) {
    //   const feature_base = new FeatureBase();
    //   feature_base.name = "Ability Score Increase";
    //   const feature = this.common_util.new_feature_of_type("Ability Score Improvement");
    //   feature.name = "Ability Score Increase";
    //   feature.feature_type = "Ability Score Improvement";
    //   // feature.the_feature = new ASIBaseFeature();
    //   (feature as ASIBaseFeature).allow_duplicates = true;
    //   (feature as ASIBaseFeature).feat_option = false;
      
    //   const asi_features: ASIFeature[] = [];
    //   if (copyMe.ability_bonuses) {
    //     copyMe.ability_bonuses.forEach((ab: any) => {
    //       const asi_feature = new ASIFeature();
    //       asi_feature.id = asi_features.length;
    //       asi_feature.amount = ab.bonus;
    //       asi_feature.options = [];
    //       asi_feature.options.push(ab.ability_score.name);
    //       asi_features.push(asi_feature);
    //     });
    //   }
    //   if (copyMe.ability_bonus_options) {
    //     const options = copyMe.ability_bonus_options;
    //     for (let i = 0; i < options.choose; i++) {
    //       const asi_feature = new ASIFeature();
    //       asi_feature.id = asi_features.length;
    //       asi_feature.options = [];
    //       options.from.forEach((ab: any) => {
    //         asi_feature.amount = ab.bonus;
    //         asi_feature.options.push(ab.ability_score.name);
    //       });
    //       asi_features.push(asi_feature);
    //     }
    //   }
    //   (feature as ASIBaseFeature).asi_features = asi_features;

    //   // feature_base.features.push(feature);
    //   this.feature_bases.push(feature_base);
    // }
    // if ((copyMe.languages && copyMe.languages.length > 0) || copyMe.language_options) {
    //   const feature_base = new FeatureBase();
    //   feature_base.name = "Languages";
    //   if (copyMe.languages) {
    //     copyMe.languages.forEach((l: any) => {
    //       const objFinder = languages.filter(o => o.name === l.name);
    //       if (objFinder.length === 1) {
    //         const feature = this.common_util.new_feature_of_type("Language");
    //         feature.name = l.name;
    //         feature.feature_type = "Language";
    //         // feature.the_feature = new LanguageFeature();
    //         (feature as LanguageFeature).type = "Specific";
    //         (feature as LanguageFeature).language_id = objFinder[0]._id;
    //         // feature_base.features.push(feature);
    //       }
    //     });
    //   }
    //   if (copyMe.language_options) {
    //     for (let i = 0; i < copyMe.language_options.choose; i++) {
    //       const feature = this.common_util.new_feature_of_type("Language");
    //       feature.name = `Language Option ${ i + 1 }`;
    //       feature.feature_type = "Language";
    //       // feature.the_feature = new LanguageFeature();
    //       (feature as LanguageFeature).type = "Standard";
    //       // feature_base.features.push(feature);
    //     }
    //   }
    //   this.feature_bases.push(feature_base);
    // }
  }
}